import { useState, useEffect, useCallback } from 'react'

function useGracefulHover(onEnter: () => void, onLeave: () => void, enterDelay: number = 500, leaveDelay: number = 500) {
  const [enterTimer, setEnterTimer] = useState<number | null>(null)
  const [leaveTimer, setLeaveTimer] = useState<number | null>(null)

  const handleMouseEnter = useCallback(() => {
    // Bricht einen möglichen leaveTimer ab und setzt ihn zurück
    if (leaveTimer) {
      clearTimeout(leaveTimer)
      setLeaveTimer(null)
    }
    // Setzt einen neuen Timer nur wenn noch kein Timer aktiv ist
    if (!enterTimer) {
      const newEnterTimer = setTimeout(() => {
        onEnter()
      }, enterDelay)
      setEnterTimer(newEnterTimer)
    }
  }, [onEnter, enterDelay, enterTimer, leaveTimer])

  const handleMouseLeave = useCallback(() => {
    // Bricht einen möglichen enterTimer ab und setzt ihn zurück
    if (enterTimer) {
      clearTimeout(enterTimer)
      setEnterTimer(null)
    }
    // Setzt einen neuen Timer nur wenn noch kein Timer aktiv ist
    if (!leaveTimer) {
      const newLeaveTimer = setTimeout(() => {
        onLeave()
      }, leaveDelay)
      setLeaveTimer(newLeaveTimer)
    }
  }, [onLeave, leaveDelay, enterTimer, leaveTimer])

  useEffect(() => {
    // Bereinigungsfunktion, die sicherstellt, dass alle Timer bei der Demontage der Komponente gelöscht werden
    return () => {
      if (enterTimer !== null) clearTimeout(enterTimer)
      if (leaveTimer !== null) clearTimeout(leaveTimer)
    }
  }, [enterTimer, leaveTimer])

  return { handleMouseEnter, handleMouseLeave }
}

export default useGracefulHover
